<div class="row mx-6 my-5 g-0 view-document-dropdown-container ">
   
@if(!showSupportingDocument()){
  <div 
  class="d-flex align-items-center dz-upload needsclick drag-drop-container "
  (dragover)="onDragOver($event)" 
  (dragleave)="onDragLeave($event)" 
  (drop)="onDrop($event)"
  [class.drag-over]="isDragOver()">

  <!-- @if(selectedFiles().length === 0){ -->
    <!-- Show drop area text only if no file selected -->
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#A99333" class="bi bi-file-earmark-arrow-up-fill" viewBox="0 0 16 16">
      <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707z"/>
    </svg>

    <div class="ms-4 text-start">
      <h3 class="fs-4 fw-bold text-gray-900 mb-1">
        Drag your Supporting file(s) or 
        <span (click)="fileInput.click()" class="browserBtn cursor-pointer">browse</span>
      </h3>
      <input type="file" #fileInput hidden (change)="onFileSelected($event)" [accept]="this.allowedDocExtensionName()" multiple/>
      <span class="fw-semibold fs-7 text-muted">
        Only support {{allowedDocExtensionName()}} within {{maxAllowedUploadSize()}}mb
      </span>
    </div>
  <!-- } -->

</div>

<!-- Selected files list -->
<div class="mt-4" *ngIf="selectedFiles().length > 0" >
  <div *ngFor="let file of selectedFiles(); let i = index" class="d-flex align-items-center justify-content-between border p-3 mb-2 rounded bg-light">
    <div class="text-truncate" style="max-width: 300px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="34px" height="34px" fill="#198754" class="bi bi-file-earmark-check-fill" viewBox="0 0 16 16">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
            </svg> {{file.name}}
    </div>
    <div class="d-flex">
            <div [attr.title]="'Upload'" class="border border-2 border-secondary rounded w-40px p-2">
      <!-- Upload Icon -->
      <svg class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" 
           xmlns="http://www.w3.org/2000/svg" stroke="green" (click)="uploadSingleFile(file)">
        <path d="M21 15C20.4477 15 20 15.4477 20 16V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V16C4 15.4477 3.55228 15 3 15C2.44772 15 2 15.4477 2 16V20C2 22.2091 3.79086 24 6 24H18C20.2091 24 22 22.2091 22 20V16C22 15.4477 21.5523 15 21 15Z" 
              fill="green" stroke-linejoin="round"/>
        <path d="M17 8L12 3L7 8" stroke="green" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 3V15" stroke="green" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </div>
      <!-- Cancel Icon -->
                   <div [attr.title]="'cancel'" class="border border-2 border-secondary rounded w-40px p-2">

      <!-- <i class="bi bi-x-circle-fill text-danger cursor-pointer" (click)="removeFile(i)"></i> -->
      <svg fill="#000000" viewBox="0 0 1024 1024" (click)="removeFile(i)" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M697.4 759.2l61.8-61.8L573.8 512l185.4-185.4-61.8-61.8L512 450.2 326.6 264.8l-61.8 61.8L450.2 512 264.8 697.4l61.8 61.8L512 573.8z"></path></g></svg>
    </div>
    </div>
  </div>
</div>

}
    
@if(showSupportingDocument()){
    
    <div class="d-flex align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" fill="#A99333" class="bi bi-file-earmark-check-fill" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
        </svg>

        <div class="ms-4 flex-grow-1 d-flex justify-content-between">
            <h4 class="fs-4 fw-bold text-gray-900 mb-1">Supporting Documents <span class="w-20px px-6 py-1 rounded-pill pill-bg fs-7 ms-2">{{ uploadedDocumentCount()}} </span></h4>
            <!-- <button type="button" class="btn btn-sm btn-outline-primary" (click)="addAnotherDocument()">+</button> -->

            @if(showDocumentList()){
            <div (click)="toogleDocumentList(false)" role="button">
                <svg class="cursor-pointer" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier"> <path d="M6 15L12 9L18 15" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </g>
                </svg>
            </div>
        } @else {
            <div (click)="toogleDocumentList(true)" role="button">
                <svg class="cursor-pointer" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier"> <path d="M6 9L12 15L18 9" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> 
                    </g>
                </svg>
            </div>
        }
        </div>
    </div>
}

@if(onUploadErrorMessage()){
    <div class="uploadErrorMsg my-2">{{ onUploadErrorMessage() }}</div>
}
    <app-toast></app-toast>
</div>

@if(showDocumentList()){
<div #scrollContainer  class="shadow-lg document-list-container bg-white" >
    <div class="p-5 mb-5">
        <div *ngFor="let document of uploadedDocuments()" class="d-flex align-items-center border border-2 border-secondary mb-3 px-3 py-3 rounded cont">
             @if(document.isDeleted === 0) {
            <svg xmlns="http://www.w3.org/2000/svg" width="34px" height="34px" fill="#198754" class="bi bi-file-earmark-check-fill" viewBox="0 0 16 16">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
            </svg>
        }
        @if(document.isDeleted === 1) {
                <svg xmlns="http://www.w3.org/2000/svg" width="34px" height="34px" fill="#f8285a" class="bi bi-file-earmark-check-fill" viewBox="0 0 16 16">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
            </svg>
        }
            <div class="ms-4 text-start flex-grow-1">
                <!-- <a (click)="openDocument(document.documentId)" style="cursor: pointer; text-decoration: underline;">
                  <h4 class="fs-6 fw-bold text-gray-900 mb-1">{{ document.documentName }}</h4>
                </a> -->
                <!-- <a [href]="viewDocument(document.documentId)" target="_blank"> 
                    <h4 class="fs-6 fw-bold text-gray-900 mb-1">{{ document.documentName }}</h4>
                </a>   -->
                <a href="javascript:void(0)" draggable="false" (click)="downloadAndOpenDocument(document.documentId, document.documentName)">
                    <h4 class="fs-6 fw-bold text-gray-900 mb-1">{{ document.documentName }}</h4>
                  </a>
                <span class="fw-semibold fs-9 text-muted">{{ document.fileSize }}kb</span>
              </div>
              <!-- delete Icon -->
            <div [attr.title]="'Delete'" class="border border-2 border-secondary rounded w-40px p-2">
                <svg class="cursor-pointer" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fe2020" (click)="deleteDocument(document.documentId)">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path d="M10 10V16M14 10V16M18 6V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V6M4 6H20M15 6V5C15 3.89543 14.1046 3 13 3H11C9.89543 3 9 3.89543 9 5V6" stroke="#fe2020" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                </svg>
               
            </div>
            <!-- download Icon -->
            <div [attr.title]="'Download'" class="border border-2 border-secondary rounded w-40px p-2">             
                  
                  <svg class="cursor-pointer" width="24px" height="24px" viewBox="0 0 24 24" fill="none" 
     xmlns="http://www.w3.org/2000/svg" stroke="green" (click)="downloadDocument(document.documentId, document.documentName)">
  <path d="M21 15C20.4477 15 20 15.4477 20 16V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V16C4 15.4477 3.55228 15 3 15C2.44772 15 2 15.4477 2 16V20C2 22.2091 3.79086 24 6 24H18C20.2091 24 22 22.2091 22 20V16C22 15.4477 21.5523 15 21 15Z" 
        fill="green" stroke-linejoin="round"/>
  
  <!-- Flipped arrow group -->
  <g transform="rotate(180 12 9)">
    <path d="M17 8L12 3L7 8" stroke="green" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 3V15" stroke="green" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</svg>

                  <!-- <svg class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="green" (click)="downloadDocument(document.documentId, document.documentName)">
                      <path d="M21 15C20.4477 15 20 15.4477 20 16V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V16C4 15.4477 3.55228 15 3 15C2.44772 15 2 15.4477 2 16V20C2 22.2091 3.79086 24 6 24H18C20.2091 24 22 22.2091 22 20V16C22 15.4477 21.5523 15 21 15Z" fill="green" stroke-linejoin="round"/>
                      <path d="M17 8L12 3L7 8" stroke="green" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 3V15" stroke="green" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg> -->
            </div>
        </div>
<!-- Drag-drop area -->

<div 
  class="d-flex align-items-center dz-upload needsclick drag-drop-container "
  (dragover)="onDragOver($event)" 
  (dragleave)="onDragLeave($event)" 
  (drop)="onDrop($event)"
  [class.drag-over]="isDragOver()">

  <!-- @if(selectedFiles().length === 0){ -->
    <!-- Show drop area text only if no file selected -->
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#A99333" class="bi bi-file-earmark-arrow-up-fill" viewBox="0 0 16 16">
      <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707z"/>
    </svg>

    <div class="ms-4 text-start">
      <h3 class="fs-4 fw-bold text-gray-900 mb-1">
        Drag your Supporting file(s) or 
        <span (click)="fileInput.click()" class="browserBtn cursor-pointer">browse</span>
      </h3>
      <input type="file" #fileInput hidden (change)="onFileSelected($event)" [accept]="this.allowedDocExtensionName()" multiple/>
      <span class="fw-semibold fs-7 text-muted">
        Only support {{allowedDocExtensionName()}} within {{maxAllowedUploadSize()}}mb
      </span>
    </div>
  <!-- } -->

</div>

<!-- Selected files list -->
<div class="mt-4" *ngIf="selectedFiles().length > 0">
  <div *ngFor="let file of selectedFiles(); let i = index" class="d-flex align-items-center justify-content-between border p-3 mb-2 rounded bg-light">
    <div class="text-truncate" style="max-width: 300px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="34px" height="34px" fill="#198754" class="bi bi-file-earmark-check-fill" viewBox="0 0 16 16">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
            </svg> {{file.name}}
    </div>
    <div class="d-flex">
            <div [attr.title]="'Upload'" class="border border-2 border-secondary rounded w-40px p-2">
      <!-- Upload Icon -->
      <svg class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" 
           xmlns="http://www.w3.org/2000/svg" stroke="green" (click)="uploadSingleFile(file)">
        <path d="M21 15C20.4477 15 20 15.4477 20 16V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V16C4 15.4477 3.55228 15 3 15C2.44772 15 2 15.4477 2 16V20C2 22.2091 3.79086 24 6 24H18C20.2091 24 22 22.2091 22 20V16C22 15.4477 21.5523 15 21 15Z" 
              fill="green" stroke-linejoin="round"/>
        <path d="M17 8L12 3L7 8" stroke="green" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 3V15" stroke="green" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </div>
      <!-- Cancel Icon -->
                   <div [attr.title]="'cancel'" class="border border-2 border-secondary rounded w-40px p-2">

      <!-- <i class="bi bi-x-circle-fill text-danger cursor-pointer" (click)="removeFile(i)"></i> -->
      <svg fill="#000000" viewBox="0 0 1024 1024" (click)="removeFile(i)" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M697.4 759.2l61.8-61.8L573.8 512l185.4-185.4-61.8-61.8L512 450.2 326.6 264.8l-61.8 61.8L450.2 512 264.8 697.4l61.8 61.8L512 573.8z"></path></g></svg>
    </div>
    </div>
  </div>
</div>


        <!-- <div *ngIf="showUploadButton()" class="mt-2">
            <button type="button" class="btn btn-primary" (click)="uploadMultipleFiles()">Upload Selected Files</button>
          </div> -->
    </div>
</div>

}